import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiArrowRight, FiLock } = FiIcons;

const LeadForm = ({ theme = 'blue' }) => {
  const navigate = useNavigate();
  const isGreen = theme === 'green';
  const isCetelem = theme.includes('cetelem');
  
  // Color Logic
  let primaryColor = '#2563eb'; // Default Blue
  let buttonClass = 'bg-blue-600 hover:bg-blue-700 text-white shadow-blue-100';
  
  if (isGreen) {
    primaryColor = '#00a651';
    buttonClass = 'bg-[#00a651] hover:bg-[#008541] text-white shadow-green-100';
  } else if (theme === 'cetelem-modern') {
    primaryColor = '#009b65';
    buttonClass = 'bg-[#009b65] hover:bg-[#007d40] text-white shadow-lg rounded-full';
  } else if (theme === 'cetelem-turquoise') {
    primaryColor = '#00a48c'; // Turquoise Cetelem
    // Gradient Button for Turquoise theme
    buttonClass = 'bg-[#00a48c] hover:bg-[#00856f] text-white shadow-xl rounded-full uppercase tracking-wider';
  }

  const [formData, setFormData] = useState({
    firstName: '', lastName: '', email: '', phone: '', tmi: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simule un appel réseau
    setTimeout(() => {
      // Redirige vers la page de remerciement
      navigate('/merci');
    }, 1500);
  };

  // Layout for Cetelem Integration
  if (isCetelem) {
    return (
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-2 gap-6">
          <div className="space-y-1">
            <label className="text-sm font-bold text-gray-500 ml-1">Prénom</label>
            <input 
              type="text" required 
              className="w-full px-5 py-4 rounded-2xl bg-gray-50 border border-gray-200 focus:bg-white focus:border-[#00a48c] outline-none font-bold text-gray-800 transition-all"
              style={{ '--tw-ring-color': primaryColor }}
              value={formData.firstName} onChange={(e) => setFormData({...formData, firstName: e.target.value})} 
            />
          </div>
          <div className="space-y-1">
            <label className="text-sm font-bold text-gray-500 ml-1">Nom</label>
            <input 
              type="text" required 
              className="w-full px-5 py-4 rounded-2xl bg-gray-50 border border-gray-200 focus:bg-white focus:border-[#00a48c] outline-none font-bold text-gray-800 transition-all"
              value={formData.lastName} onChange={(e) => setFormData({...formData, lastName: e.target.value})} 
            />
          </div>
        </div>
        
        <div className="space-y-1">
            <label className="text-sm font-bold text-gray-500 ml-1">Email</label>
            <input 
            type="email" required 
            className="w-full px-5 py-4 rounded-2xl bg-gray-50 border border-gray-200 focus:bg-white focus:border-[#00a48c] outline-none font-bold text-gray-800 transition-all"
            value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} 
            />
        </div>

        <div className="grid grid-cols-2 gap-6">
            <div className="space-y-1">
                <label className="text-sm font-bold text-gray-500 ml-1">Téléphone</label>
                <input 
                type="tel" required 
                className="w-full px-5 py-4 rounded-2xl bg-gray-50 border border-gray-200 focus:bg-white focus:border-[#00a48c] outline-none font-bold text-gray-800 transition-all"
                value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} 
                />
            </div>
            <div className="space-y-1">
                <label className="text-sm font-bold text-gray-500 ml-1">Votre TMI</label>
                <select 
                className="w-full px-5 py-4 rounded-2xl bg-gray-50 border border-gray-200 focus:bg-white focus:border-[#00a48c] outline-none font-bold text-gray-800 transition-all appearance-none" 
                required value={formData.tmi} onChange={(e) => setFormData({...formData, tmi: e.target.value})}
                >
                <option value="">Sélectionner</option>
                <option value="11">11%</option>
                <option value="30">30%</option>
                <option value="41">41%</option>
                <option value="45">45%</option>
                </select>
            </div>
        </div>

        <button 
          type="submit" disabled={isSubmitting} 
          className={`w-full py-5 font-black text-xl transition-all flex items-center justify-center group ${buttonClass} mt-6`}
        >
          {isSubmitting ? "CALCUL EN COURS..." : "VOIR MON ÉCONOMIE"}
          {!isSubmitting && <SafeIcon icon={FiArrowRight} className="ml-2" />}
        </button>
        
        <div className="flex items-center justify-center gap-2 text-gray-400 text-xs font-semibold mt-4">
            <SafeIcon icon={FiLock} />
            <span>Vos données sont protégées et cryptées</span>
        </div>
      </form>
    );
  }
  
  // Default fallback...
  return <div>Formulaire standard</div>;
};

export default LeadForm;